import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["timeDelay"],
  _excluded2 = ["timeDelay"];
import TimeDelay from 'automation-ui-flow-core/fields/time/TimeDelay';
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
export default class RelativeDatetimeField extends createImmutableObjectClass({
  timeDelay: null,
  valueType: 'RELATIVE_DATETIME'
}, {
  fromJSON: _ref => {
    let {
        timeDelay
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return Object.assign({}, rest, {
      timeDelay: new TimeDelay(timeDelay || {})
    });
  },
  toJSON: _ref2 => {
    let {
        timeDelay
      } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    return Object.assign({}, rest, {
      timeDelay: (timeDelay === null || timeDelay === void 0 ? void 0 : timeDelay.toJSON()) || null
    });
  }
}) {
  getIsValueEmpty() {
    return !this.timeDelay || this.timeDelay.delta === null;
  }
  /**
   * @deprecated Prefer dot notation: .timeDelay
   */
  getTimeDelay() {
    return this.timeDelay;
  }
  getValue() {
    return this.timeDelay;
  }
  /**
   * @deprecated Prefer dot notation: .valueType
   */
  getValueType() {
    return this.valueType;
  }
}